export const colors = {
  navy: '#0F172A',
  navyDark: '#020617',
  navyLight: '#1E293B',
  navyMid: '#334155',
  blue: '#64748B',
  blueLight: '#94A3B8',
  blueDeep: '#475569',
  silver: '#C0C7D1',
  silverLight: '#E2E8F0',
  silverDark: '#94A3B8',
  gold: '#eeba2b',
  goldLight: '#f5d061',
  goldDark: '#c9970f',
  ochre: '#D4A017',
  ochreLight: '#E8C047',
  ochreMuted: 'rgba(232, 192, 71, 0.82)',
  spaceBlue: '#061B3A',
  spaceBlueMid: '#0A2F5C',
  spaceBlueDeep: '#030E22',
  white: '#ffffff',
  offWhite: '#F8FAFC',
  slate: '#64748B',
  text: '#0F172A',
  textMuted: 'rgba(255,255,255,0.72)',
  purple: '#5e3c91',
  purpleDeep: '#2a1771',
  purpleSoft: '#766593',
  border: 'rgba(148, 163, 184, 0.28)',
  borderLight: 'rgba(15, 23, 42, 0.08)',
  glass: 'rgba(255, 255, 255, 0.05)',
  glassBorder: 'rgba(255, 255, 255, 0.1)',
  glassLight: 'rgba(255, 255, 255, 0.82)',
  glassLightBorder: 'rgba(255, 255, 255, 0.5)',
};

export const gradients = {
  hero: 'linear-gradient(165deg, #020817 0%, #061225 38%, #0A1F3D 72%, #0C2748 100%)',
  heroBlue: 'linear-gradient(135deg, #020817 0%, #061B3A 50%, #0A2F5C 100%)',
  heroSpace: 'radial-gradient(ellipse at 50% 20%, rgba(14, 58, 107, 0.35) 0%, transparent 55%), linear-gradient(165deg, #020817 0%, #061225 42%, #0A1F3D 100%)',
  heroLight: 'linear-gradient(180deg, #ffffff 0%, #F8FAFC 55%, #F1F5F9 100%)',
  heroOverlay: 'linear-gradient(to top, rgba(3,14,34,0.92) 0%, rgba(6,27,58,0.4) 50%, rgba(6,27,58,0.1) 100%)',
  gold: 'linear-gradient(135deg, #eeba2b 0%, #f5d061 50%, #c9970f 100%)',
  ochre: 'linear-gradient(135deg, #C9970F 0%, #D4A017 45%, #E8C047 100%)',
  silver: 'linear-gradient(135deg, #94A3B8 0%, #C0C7D1 50%, #E2E8F0 100%)',
  navy: 'linear-gradient(135deg, #020617 0%, #0F172A 55%, #1E293B 100%)',
  blue: 'linear-gradient(135deg, #64748B 0%, #475569 50%, #334155 100%)',
  blueGlow: 'radial-gradient(circle at 30% 50%, rgba(148,163,184,0.18) 0%, transparent 60%)',
  card: 'linear-gradient(145deg, #1E293B 0%, #0F172A 100%)',
  cardAlt: 'linear-gradient(145deg, #1E293B 0%, #020617 100%)',
  sectionLight: 'linear-gradient(180deg, #ffffff 0%, #F8FAFC 100%)',
  sectionDark: 'linear-gradient(165deg, #020617 0%, #0F172A 48%, #1E293B 100%)',
  sectionSoft: 'linear-gradient(180deg, #F8FAFC 0%, #ffffff 50%, #F1F5F9 100%)',
  footer: 'linear-gradient(160deg, #0F172A 0%, #020617 55%, #0a192f 100%)',
  cta: 'linear-gradient(135deg, #020617 0%, #0F172A 60%, #1E293B 100%)',
  mesh: 'radial-gradient(at 40% 20%, rgba(148,163,184,0.12) 0px, transparent 50%), radial-gradient(at 80% 0%, rgba(226,232,240,0.06) 0px, transparent 50%), radial-gradient(at 0% 50%, rgba(30,41,59,0.35) 0px, transparent 50%)',
};

export const shadows = {
  sm: '0 2px 8px rgba(15, 23, 42, 0.06)',
  md: '0 8px 32px rgba(15, 23, 42, 0.1)',
  lg: '0 16px 48px rgba(15, 23, 42, 0.14)',
  xl: '0 24px 64px rgba(15, 23, 42, 0.18)',
  gold: '0 4px 24px rgba(238, 186, 43, 0.25)',
  blue: '0 4px 24px rgba(100, 116, 139, 0.25)',
  silver: '0 4px 24px rgba(148, 163, 184, 0.3)',
  card: '0 8px 32px rgba(15, 23, 42, 0.2)',
  hero: '0 20px 60px rgba(15, 23, 42, 0.15)',
  glass: '0 8px 32px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255,255,255,0.08)',
};

export const radii = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  pill: '999px',
};

export const glass = {
  dark: {
    background: colors.glass,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    border: `1px solid ${colors.glassBorder}`,
    boxShadow: shadows.glass,
  },
  light: {
    background: colors.glassLight,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    border: `1px solid ${colors.glassLightBorder}`,
    boxShadow: shadows.glass,
  },
};

export const motion = {
  ease: [0.22, 1, 0.36, 1],
  duration: 0.55,
  stagger: 0.08,
};

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

export const slideIn = {
  hidden: { opacity: 0, x: -24 },
  visible: (i = 0) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

/** Base sharp rendering for all images */
export const sharpImageSx = {
  display: 'block',
  maxWidth: '100%',
  imageRendering: 'auto',
  WebkitBackfaceVisibility: 'hidden',
  backfaceVisibility: 'hidden',
};

/** Fill a fixed frame edge-to-edge (photos, banners) */
export const fillImageSx = {
  ...sharpImageSx,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
};

/** Logos and icons — preserve aspect ratio inside a box */
export const containImageSx = {
  ...sharpImageSx,
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  objectPosition: 'center',
};
